import React, { useEffect, useState } from 'react';
export function CustomCursor() {
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const [isVisible, setIsVisible] = useState(false);
  const [isPointerDevice, setIsPointerDevice] = useState(false);
  useEffect(() => {
    // Check if device has fine pointer (mouse)
    const mediaQuery = window.matchMedia('(pointer: fine)');
    setIsPointerDevice(mediaQuery.matches);
    const handleChange = (e: MediaQueryListEvent) => {
      setIsPointerDevice(e.matches);
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);
  useEffect(() => {
    if (!isPointerDevice) return;
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({
        x: e.clientX,
        y: e.clientY
      });
      setIsVisible(true);
    };
    const handleMouseLeave = () => {
      setIsVisible(false);
    };
    const handleMouseEnter = () => {
      setIsVisible(true);
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseenter', handleMouseEnter);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [isPointerDevice]);
  if (!isPointerDevice || !isVisible) return null;
  return <div className="fixed pointer-events-none z-[9999]" style={{
    left: position.x,
    top: position.y,
    transform: 'translate(-50%, -50%)'
  }} data-id="element-84">
      {/* Crosshair vertical line */}
      <div className="absolute left-1/2 -translate-x-1/2 w-px h-6 bg-white/50" style={{
      top: '-12px'
    }} data-id="element-85" />
      {/* Crosshair horizontal line */}
      <div className="absolute top-1/2 -translate-y-1/2 h-px w-6 bg-white/50" style={{
      left: '-12px'
    }} data-id="element-86" />
      {/* Coordinates */}
      <div className="absolute font-mono text-[10px] text-white/30 whitespace-nowrap" style={{
      left: '16px',
      top: '16px'
    }} data-id="element-87">
        x: {Math.round(position.x)} y: {Math.round(position.y)}
      </div>
    </div>;
}